import { useTranslation } from 'react-i18next';
import { IconButton } from '~/ui';
import Basket from '~/assets/svg/newSvg/basket.svg?react';
import {
  Table,
  TableBody,
  TableCell,
  TableCellHead,
  TableHead,
  TableRow,
} from '~/ui/Table';
import ModalConfirm from '~/components/Shared/ModalConfirm';
import styles from './PriceListTable.module.scss';

interface IPriceTableProps {
  sort: { field: string; direction: string };
  setSort: ({ field, direction }: { field: string; direction: string }) => void;
  data: { id: number; name: string }[];
  deletePrice: (id: number) => void;
}

const PriceListTable = ({
  sort,
  setSort,
  data,
  deletePrice,
}: IPriceTableProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <Table>
        <TableHead sort={sort} setSort={setSort}>
          <TableCellHead field="name" sortable={false}>
            {t('name')}
          </TableCellHead>
          <TableCellHead
            field="actions"
            sortable={false}
            className={styles.action}
          >
            {t('actions')}
          </TableCellHead>
        </TableHead>
        <TableBody>
          {data?.map(item => (
            <TableRow key={item.id}>
              <TableCell>{item.name}</TableCell>
              <TableCell className={styles.actionField}>
                <div className={styles.slotsUsersTableActions}>
                  <ModalConfirm
                    title={`${t('sure_to_delete_file')}?`}
                    description={t('impossible_return_file')}
                    onConfirm={() => {
                      deletePrice(item.id);
                    }}
                  >
                    {open => (
                      <IconButton
                        // @ts-ignore
                        onClick={event => {
                          event.stopPropagation();
                          open();
                        }}
                      >
                        <Basket />
                      </IconButton>
                    )}
                  </ModalConfirm>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default PriceListTable;
